import { render, staticRenderFns } from "./ApprovalQueue.vue?vue&type=template&id=ebc169c4&scoped=true"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js"
import style0 from "./ApprovalQueue.vue?vue&type=style&index=0&id=ebc169c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc169c4",
  null
  
)

export default component.exports